import { Link } from "react-router-dom";
import { faqList } from "@/mocks/faq";

export default function FaqPreview() {
  return (
    <section className="mx-auto max-w-container px-4 py-12 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <span className="text-xs font-semibold uppercase tracking-widest text-accent-600">常见问题</span>
          <h2 className="mt-2 text-2xl text-foreground-950 md:text-3xl">关于热瓜雷达，你可能想问</h2>
          <p className="mt-3 text-sm leading-6 text-foreground-600">
            从内容可信度到投稿方式，我们在这里把话说明白。还有疑问，随时通过关于页的联系邮箱找我们。
          </p>
          <Link to="/faq" className="mt-5 inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-primary-300 px-5 py-2.5 text-sm text-primary-700 transition hover:bg-primary-100">
            查看全部 FAQ <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="space-y-3 lg:col-span-8">
          {faqList.slice(0, 4).map((f) => (
            <details key={f.q} className="group rounded-2xl border border-background-200 bg-background-50 px-5">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 py-4">
                <span className="text-sm font-semibold text-foreground-900">{f.q}</span>
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition group-open:rotate-45 group-open:bg-primary-500 group-open:text-background-50">
                  <i className="ri-add-line"></i>
                </span>
              </summary>
              <p className="pb-4 text-sm leading-7 text-foreground-600">{f.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}